// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mSKw","label":"styles_label__ZgRth"};